module.exports = "<div *ngIf=\"model\">\r\n    <announcer [model]=\"model.announcer\" *ngIf=\"model.announcer\"></announcer>\r\n    <quote [model]=\"model.quote\" *ngIf=\"model.quote\"></quote>\r\n    <slide-show [model]=\"model.slideshow\" *ngIf=\"model.slideshow\"></slide-show>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ceremony/ceremony.component.html
// module id = ./src/app/ceremony/ceremony.component.html
// module chunks = main